import {BrowserRouter, Routes, Route} from "react-router-dom";

import ScrollToTopOnRouteChange from "../components/ScrollToTopOnRouteChange";
import AboutUs from "../pages/aboutUs";
import Home from "../pages/home";
import Industries from "../pages/industries";
import Privacy from "../pages/Privacy";
import Projects from "../pages/project";
import OrganicPackage from "../pages/project/organicPackagePlant";
import LaserScanning from "../pages/servicess/3DLaserScanning";
import EmissionsMeasurements from "../pages/servicess/emissionsMeasurements";
import InstallationService from "../pages/servicess/installationServices";
import LaboratoryTesting from "../pages/servicess/laboratoryTesting";
import NonDestructiveTesting from "../pages/servicess/nonDestructiveTesting";
import PlantInspections from "../pages/servicess/plantInspections";
import Acid from "../pages/solutions/acid";
import AcidFumes from "../pages/solutions/acidFumes";
import Desulphurisation from "../pages/solutions/desulphurisation";
import Fertilizer from "../pages/solutions/fertilizer";
import Hydrogen from "../pages/solutions/hydrogen";
import OffGasTreatment from "../pages/solutions/offGasTreatment";
import Organic from "../pages/solutions/organic";
import OrganicWaste from "../pages/solutions/organicWaste";
import VocOdourControl from "../pages/solutions/vocOdourControl";
import Brink from "../pages/technologies/brinkMistEliminator";
import Carbon from "../pages/technologies/carbon";
import Gas from "../pages/technologies/gas";
import MeshPads from "../pages/technologies/meshPads";
import Sap from "../pages/technologies/sapTechnologies";
import ComingSoon from "../pages/comingSoon";

const comingSoonOnly = process.env.REACT_APP_COMING_SOON === "true";

function AppRoutes() {
  const activeRoutes = comingSoonOnly
    ? [{path: "*", element: <ComingSoon />}]
    : [
        {path: "/coming-soon", element: <ComingSoon />},
        {path: "/", element: <Home />},
        {path: "/privacy", element: <Privacy />},
        {path: "/desulphurisation", element: <Desulphurisation />},
        {path: "/acid", element: <Acid />},
        {path: "/vocodourcontrol", element: <VocOdourControl />},
        {path: "/acidfumes", element: <AcidFumes />},
        {path: "/organic", element: <Organic />},
        {path: "/offgastreatment", element: <OffGasTreatment />},
        {path: "/organic-waste", element: <OrganicWaste />},
        {path: "/fertilizer", element: <Fertilizer />},
        {path: "/hydrogen", element: <Hydrogen />},
        {path: "/industries", element: <Industries />},
        {path: "/carbon", element: <Carbon />},
        {path: "/meshpads", element: <MeshPads />},
        {path: "/gas", element: <Gas />},
        {path: "/brink", element: <Brink />},
        {path: "/sap", element: <Sap />},
        {path: "/organic-package", element: <OrganicPackage />},
        {path: "/aboutus", element: <AboutUs />},
        {path: "/projects", element: <Projects />},
        {path: "/installation-services", element: <InstallationService />},
        {path: "/plant-inspections", element: <PlantInspections />},
        {path: "/non-destructive-testing", element: <NonDestructiveTesting />},
        {path: "/laser-scanning", element: <LaserScanning />},
        {path: "/emissions-measurements", element: <EmissionsMeasurements />},
        {path: "/laboratory-testing", element: <LaboratoryTesting />},
      ];

  return (
    <BrowserRouter>
      <ScrollToTopOnRouteChange />
      <Routes>
        {activeRoutes.map((route, idx) => (
          <Route key={idx} path={route.path} element={route.element} />
        ))}
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
